import { createSelector } from '@reduxjs/toolkit';
import { modelElementsCurrentModelLoadingSelector } from '@/redux/modelElements/modelElements.selector';
import {
  arrowTypesLoadingSelector,
  bioShapesLoadingSelector,
  lineTypesLoadingSelector,
} from '@/redux/shapes/shapes.selectors';
import { layersLoadingSelector } from '@/redux/layers/layers.selectors';
import { reactionsLoadingSelector } from '@/redux/reactions/reactions.selector';

export const modelLoadingSelector = createSelector(
  [
    reactionsLoadingSelector,
    modelElementsCurrentModelLoadingSelector,
    bioShapesLoadingSelector,
    lineTypesLoadingSelector,
    arrowTypesLoadingSelector,
    layersLoadingSelector,
  ],
  (...loadingStates) => loadingStates.includes('pending'),
);

export const modelLoadedSuccessfullySelector = createSelector(
  [
    reactionsLoadingSelector,
    modelElementsCurrentModelLoadingSelector,
    bioShapesLoadingSelector,
    lineTypesLoadingSelector,
    arrowTypesLoadingSelector,
    layersLoadingSelector,
  ],
  (...loadingStates) => loadingStates.every(state => state === 'succeeded'),
);
